import { useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { processHandler } from "../chatbot";
import { timestamp, uuid } from "../messageFactory";
import { buildContactSupportMessage } from "../messageFactory";
import { useCreateChatMessage } from "../queries";

export const useChat = () => {
  const history = useHistory();

  const [sessionId, setSessionId] = useState(null);
  const [conversationType, setConversationType] = useState(null);
  const [productArea, setProductArea] = useState(null);
  const [isUserInputEnabled, setIsUserInputEnabled] = useState(false);
  const [isConversationEnded, setIsConversationEnded] = useState(false);
  const [messages, setMessages] = useState([]);

  const addMessage = (type, { ...attributes }) => {
    setMessages(oldMessages => [
      ...oldMessages,
      {
        id: uuid(),
        type,
        createdAt: timestamp(),
        ...attributes,
      },
    ]);
  };

  const { mutate: createChatMessage } = useCreateChatMessage({
    onSuccess: data => {
      setSessionId(data.result.session_id);
      setIsUserInputEnabled(true);
      let content = data.result.answer;
      let buttons = [];
      const sources = content.match(/<sources>(.*)<\/sources>/s);
      if (sources) {
        content = content.replace(sources[0], "");
        const sourcesBody = JSON.parse(sources[1]);
        const list = sourcesBody
          .filter(source => source.url !== "Not Available")
          .map(({ url, title }) => ({
            url: url
              ? url.replace(
                  "https://help-en.circle.so",
                  "https://help.circle.so",
                )
              : null,
            title,
          }))
          .map(
            source =>
              `<li><a target="_blank" href="${source.url}">${source.title}</a></li>`,
          );

        if (list.length > 0) {
          content = content.concat(
            `<h6 class="sources-title">${t(
              "support_widget.chatbot.helpful_resources",
            )}</h6><ul>${list.join("")}</ul>`,
          );
        }
      }

      if (content.match(/<ticket>(.*)<\/ticket>/s)) {
        const message = buildContactSupportMessage();

        content = message.content;
        buttons = message.buttons;

        setIsUserInputEnabled(false);
      }

      addMessage("bot", {
        content: content,
        buttons: buttons,
        showDisclaimer: true,
      });
    },
  });

  const process = processHandler({
    history,
    addMessage,
    setIsUserInputEnabled,
    setConversationType,
    setProductArea,
    conversationType,
    productArea,
    createChatMessage,
    sessionId,
    setSessionId,
    setIsConversationEnded,
  });

  return {
    sessionId,
    conversationType,
    messages,
    isUserInputEnabled,
    isConversationEnded,
    process,
  };
};
